import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-sections">
          <div className="footer-section">
            <h4>About</h4>
            <ul>
              <li><a href="/about">About Us</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Support</h4>
            <ul>
              <li><a href="/contact">Contact Us</a></li>
              <li><a href="/faq">FAQ</a></li>
              <li><a href="/feedback">Feedback</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li><a href="/privacy">Privacy Policy</a></li>
              <li><a href="/terms">Terms of Service</a></li>
              <li><a href="/cookies">Cookie Policy</a></li>
              <li><a href="/guidelines">Community Guidelines</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Connect</h4>
            <ul>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-logo-section">
            <div className="footer-brand">
              <img src="/logo.svg" alt="" className="footer-logo" style={{ opacity: 0.65 }} />
              <span>Flow.</span>
            </div>
            <p className="footer-description">
              Writing reimagined.
            </p>
          </div>

          <div className="footer-copyright">
            <p>&copy; {currentYear} Flow. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;